/// <summary>
/// This object provides js functions for sending tasks (delData, importData, etc) <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 30.04.2024<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 30.04.2024                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// *** v2.0.0 - 28.08.2024                                              *<br />
/// **********************************************************************<br />
/// * - update to vcBaseV4 and move to correct folder                    *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.SendTasks", jQuery.common.vcBaseV4, {
    vcV: new vcVisual(),
    myStatus: {
        allSelectedSignals: null, 
        filteredSignals: []
    },

    _create: function () {
        this._createVisual(354);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".send-tasks");
            me._buildHtml();
            me.myStatus.allSelectedSignals = jQuery.parseJSON(sessionStorage.getItem('allSignals')); // get all selected signals

            // we only want to show signals, no rules!
            if (me.myStatus.allSelectedSignals) {
                me.myStatus.filteredSignals = me.myStatus.allSelectedSignals.filter(function (signal) {
                    var isVirtual = (signal.isarchiverule === false && signal.issignalrule === true);
                    return !isVirtual;
                });
            }

            me._getSelectedDate(); // get selected date (selected directly in archive)
            return true;
        } catch (e) { me.writeError('_initHTML', e); return false; }
    },

    _initEvents: function () { this._initStructure(); },

    _initStructure: function () {
        /// <summary>
        /// This function inits the click handler and the response trigger of the vcMenu
        /// </summary>
        var me = this;
        try {
            me._initDateBox();
            me._initTaskBox();

            me.fnd("#div-btn-send").off("click").on("click", function () {
                me._sendTasks();
            });
        } catch (e) { me._writeErr(e); }
    },

    _initTaskBox: function () {
        /// <summary>
        /// This function creates the task box
        /// </summary>
        var me = this;
        try {
            var sendMenu = $("<div>").attr("id", "div-selection-menu").css("display", "flex").css("width", "100%");
            var divBtnSend = $("<div>").attr("id", "div-btn-send").html(me.specific.resources.send).css({
                "width": "50%",
                "margin-left": "5%"
            }).button();

            var selection = $("<select>").attr("id", "ddl-send-tasks").addClass("ddl").css("padding", "4px").css("width", "35%");
            selection.append($("<option>").val("0").text("importData"));
            selection.append($("<option>").val("1").text("delData"));
            selection.append($("<option>").val("2").text("recalcData"));
            selection.append($("<option>").val("3").text("getData"));

            sendMenu.append(selection, divBtnSend);

            me.myHtml.tasks.sendBox.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [{ button: "Tasks", clickable: true, isList: true, content: sendMenu }]
            });    

        } catch (e) { me._writeErr(e); }
    },

    _initDateBox: function () {
        /// <summary>
        /// This function creates the date box
        /// </summary>
        var me = this;
        try {
            var calRange = $("<div>").attr("id", "div-date-range");
             
            me.myHtml.tasks.dateBox.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [ { button: me.specific.resources.period, clickable: true, content: calRange, isList: false } ], callback: function () { }
            });

        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            me.myHtml = { tasks: {} };
            
            me.myHtml.tasks = me._setObj("div-send-tasks", ""); 
            let obj = me.myHtml.tasks;
            obj.height(me.myRoot.height());

            // add date and send option box
            obj.dateBox = me._setObj("m-tasks-date", "optionbox float vc-grid-margin-right boxMargins");
            obj.sendBox = me._setObj("m-tasks-send", "optionbox float vc-grid-margin-right boxMargins"); 

            // table / list of signals
            obj.wrapper = me._setWrapper("div-signal-list", "vc-list");
            obj.header = me._setListHeader("div-signal-header");
            var line = me._setListItem();
            line.column.append(me._setListElement("", "col0").html(me.specific.resources.signal).css("width", "90%"));
            obj.header.append(line.item);
            obj.data = me._setObj("", "lst-entries vc-list-table");

            obj.wrapper.append(obj.header, obj.data);
            obj.append(obj.dateBox, obj.sendBox, obj.wrapper);
            me.myRoot.append(me.myHtml.tasks);

        } catch (e) { me.writeError('_buildHtml', e); return false; }
        return true;
    },

    _sendTasks: function () {
        /// <summary>
        /// This function sends the selected task
        /// </summary>
        var me = this;
        try {
            var taskDates = me.fnd("#div-date-range").vcDate('getDate');

            var bsaids = me.myStatus.filteredSignals.map(function (s) {
                return s.id;
            });

            var param = { typeid: 3, Bsaids: bsaids, StartDate: taskDates.from, EndDate: taskDates.to, value: parseInt(me.fnd("#ddl-send-tasks").val()) }

            me.getData(param, function (result) {
                //check response content
                if (result == false) { me.showMessage(me.resources.err_loadData, true); return false; }
                alert(me.specific.resources.done);
                return true;
            });
        } catch (e) { me.writeError('_sendTasks', e); return false; }
        return true;
    },

    _getSelectedDate: function () {
        /// <summary>
        /// This function gets the date information, which is selected in the archive menu
        /// </summary>
        var me = this;
        try {
            // get data from db
            me.getData({ typeid: 1 }, function (result) {
                if (result == null) { me.showMessage(me.resources.err_loadData, true); return false; }
                me.myHtml.tasks.date = result;
                me.fnd("#div-date-range").vcDate({ mode: "Range", align: "right", interval: 1, langID: me.UserLangIDForCulture, defaultRange: { from: result[0], to: result[1] } });
                me._setElementHeights(); // set heights of elements
                me._generateList(); // generate the list/table with all signals
                return true;
            });

        } catch (e) { me.writeError('_getSelectedDate', e); return false; }
        return true;
    },
    
    _setElementHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            var parentWidth = me.fnd("#div-send-tasks").width();
            var outerH = me.fnd("#m-tasks-send").outerHeight(true);
            var hTable = me.myRoot.height() - outerH;

            me.fnd("#div-signal-list").width(parentWidth).height(hTable);

            var hHeader = me.fnd("#div-signal-header").height();
            var hList = hTable - hHeader;
            me.fnd(".lst-entries").css("height", hList);

            me.fnd("#m-tasks-date").height(me.fnd("#m-tasks-send").height());

        } catch (e) { me._writeErr(e); }
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
            var list = me.myHtml.tasks.data;

            if (me.myStatus.filteredSignals.length == 0 || me.myStatus.filteredSignals === null || me.myStatus.filteredSignals.rows === null) {
                list.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist)); return false;
            }
            
            // fill corresponding list with items
            // start with second row, because first row only contains day/month before actual selection for calculation of the daily/monthly usage
            for (var i = 0; i < me.myStatus.filteredSignals.length; i++) {
                list.append(me._fillItems(i));
            }
            me._formatTable();

        } catch (e) { me.writeError('_fillData', e); return false; }
        return true;
    },

    _fillItems: function (i) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var item = $("<div>", { "class": "vc-list-item" });
            let obj = me.myStatus.filteredSignals;
            item.append($("<div>", { "class": "vc-list-col col0" }).css("width", "90%").html($("<div>", { "class": "vc-list-col-element" + me._checkForVirtualSignal(obj[i]), "html": me._addIconSignalType(obj[i]) + "  " + obj[i].name + " [" + obj[i].dims + "]" })));
            return item;
        } catch (e) { me.writeError('_fillItems', e); return false; }
    },

    _addIconSignalType: function (obj) {
        /// <summary>
        /// This function returns the corresponding icon for virtual signal or measure
        /// </summary>
        var me = this;
        try {
            var icon = "<i class='fa fa-signal'></i>";
            if (obj.isarchiverule === false && obj.issignalrule === true)
                icon = "<i class='fa fa-magic'></i>";

            return icon;
        } catch (e) { me.writeError('_addIconSignalType', e); return false; }
    },

    _checkForVirtualSignal: function (obj) {
        /// <summary>
        /// This function checks if signal is a virtual signal; if yes, opacity of row is changed to mark virtual signals in the list
        /// </summary>
        var me = this;
        try {
            if (obj.isarchiverule === false && obj.issignalrule === true)
                return " markVirtual";
            else
                return "";
        } catch (e) { me.writeError('_checkForVirtualSignal', e); return false; }
    },

    _formatTable: function () {
        /// <summary>
        /// This function formats the table
        /// </summary>
        var me = this;
        try {
            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');
            me.fnd('.lst-entries .vc-list-item .vc-list-col-element.value').formatDouble(2);
        } catch (e) { me.writeError('_formatTable', e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) { me.fnd("#div-send-tasks").hide(); }
            return true;
        } catch (e) { me.writeError('specificInfoHandling', e); return false; }
    }
});